import { NgModule } from '@angular/core';
import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AnimatedDelayDirective, AnimatedDirective } from './shared/directives/animated.directive';
import { FlexSpacerDirective } from './shared/directives/flex-spacer.directive';
import { V2LayoutComponent } from './v2-layout.component';
import { v2LayoutRouting } from './v2-layout.routing';
import { HeaderSearchComponent } from './header/header-search/header-search.component';
import { HeaderNavigationSidenavComponent } from './header/header-navigation-sidenav/header-navigation-sidenav.component';
import { SidenavContentComponent } from './shared/sidenav/sidenav-content/sidenav-content.component';
import { HeaderMenuComponent } from './header/header-menu/header-menu.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PromoBarModule } from '../app-layout/shared/promo-bar/promo-bar.module';

@NgModule({
    imports: [
        v2LayoutRouting,
        MatSidenavModule,
        MatToolbarModule,
        AsyncPipe,
        HeaderNavigationSidenavComponent,
        SidenavContentComponent,
        HeaderSearchComponent,
        HeaderMenuComponent,
        NgClass,
        FlexSpacerDirective,
        MatSnackBarModule,
        PromoBarModule,
        NgIf,
        AnimatedDelayDirective,
        AnimatedDirective,
        MatButtonModule,
        MatIconModule,
        NgTemplateOutlet,
    ],
    declarations: [V2LayoutComponent],
    exports: [],
})
export class V2LayoutModule
{
}
